import { render, staticRenderFns } from "./EmployeePermissions.vue?vue&type=template&id=2c2363f8&scoped=true&"
import script from "./EmployeePermissions.vue?vue&type=script&lang=ts&"
export * from "./EmployeePermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2363f8",
  null
  
)

export default component.exports